import { render, staticRenderFns } from "./LiveAddExternalLinkForm.vue?vue&type=template&id=b5fcaf1c"
import script from "./LiveAddExternalLinkForm.vue?vue&type=script&lang=js"
export * from "./LiveAddExternalLinkForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports